/** 현장 안전 SMS(알리고·웹훅) — 시스템 설정 UI / API */

export type SafetySmsProvider = 'auto' | 'log' | 'webhook' | 'aligo';
export type SafetySmsWebhookFormat = 'generic' | 'aligo_form';

export interface SafetySmsSettings {
  provider: SafetySmsProvider;
  aligo_api_url: string;
  aligo_api_key: string;
  aligo_user_id: string;
  aligo_sender: string;
  aligo_test_mode: boolean;
  aligo_lms_title: string;
  webhook_url: string;
  webhook_format: SafetySmsWebhookFormat;
  webhook_batch: boolean;
  timeout_sec: number;
}

export const DEFAULT_SAFETY_SMS_SETTINGS: SafetySmsSettings = {
  provider: 'auto',
  aligo_api_url: 'https://apis.aligo.in/send/',
  aligo_api_key: '',
  aligo_user_id: '',
  aligo_sender: '',
  aligo_test_mode: true,
  aligo_lms_title: '시설 안전알림',
  webhook_url: '',
  webhook_format: 'generic',
  webhook_batch: false,
  timeout_sec: 12,
};

export function mergeSafetySmsSettings(
  partial?: Partial<SafetySmsSettings> | null
): SafetySmsSettings {
  const p = partial || {};
  const d = DEFAULT_SAFETY_SMS_SETTINGS;
  const prov = String(p.provider || d.provider).toLowerCase();
  const provider: SafetySmsProvider =
    prov === 'log' || prov === 'webhook' || prov === 'aligo' ? prov : 'auto';
  const wf = String(p.webhook_format || d.webhook_format).toLowerCase();
  const webhook_format: SafetySmsWebhookFormat =
    wf === 'aligo_form' ? 'aligo_form' : 'generic';
  const bool = (v: unknown, fallback: boolean) => {
    if (typeof v === 'boolean') return v;
    if (v === 'true' || v === '1') return true;
    if (v === 'false' || v === '0') return false;
    return fallback;
  };
  const num = (v: unknown, fallback: number) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : fallback;
  };
  return {
    provider,
    aligo_api_url: String(p.aligo_api_url ?? d.aligo_api_url).trim() || d.aligo_api_url,
    aligo_api_key: String(p.aligo_api_key ?? d.aligo_api_key),
    aligo_user_id: String(p.aligo_user_id ?? d.aligo_user_id).trim(),
    aligo_sender: String(p.aligo_sender ?? d.aligo_sender).trim(),
    aligo_test_mode: bool(p.aligo_test_mode, d.aligo_test_mode),
    aligo_lms_title: String(p.aligo_lms_title ?? d.aligo_lms_title).trim() || d.aligo_lms_title,
    webhook_url: String(p.webhook_url ?? d.webhook_url).trim(),
    webhook_format,
    webhook_batch: bool(p.webhook_batch, d.webhook_batch),
    timeout_sec: Math.min(60, Math.max(3, Math.floor(num(p.timeout_sec, d.timeout_sec)))),
  };
}
